<template>
  <v-menu
    :close-on-content-click="false"
    :nudge-width="200"
    offset-x
    bottom
    origin="center center"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <a
        class="filtro"
        color="indigo"
        dark
        v-on="on"
      >
        <v-icon
          left
          color="#F7A400"
        >mdi-filter-variant</v-icon> <span style="color:#000">Filtro</span>
      </a>
    </template>

    <v-card class="px-3 py-3">
      <div class="title pl-3">Filtre o tipo de teste</div>
      <v-container fluid>
        <v-card flat max-width="300">
          <v-row>
            <v-col class="12" md="12">
              <v-autocomplete
                v-model="filter.category"
                :items="categories"
                item-text="text"
                item-value="key"
                outlined
                label="Categoria"
                dense
                small-chips
                hide-details
              ></v-autocomplete>
            </v-col>
            <v-col class="12" md="12">
              <v-autocomplete
                v-model="filter.areas"
                :items="getTrainingAreas($i18n.locale)"
                item-text="text"
                item-value="key"
                outlined
                label="Áreas de formação"
                dense
                multiple
                small-chips
                hide-details
              ></v-autocomplete>
            </v-col>
            <v-col class="12" md="12">
              <v-autocomplete
                v-model="filter.positions"
                :items="getPositions($i18n.locale)"
                item-text="text"
                item-value="key"
                outlined
                label="Cargos"
                dense
                multiple
                small-chips
                hide-details
              ></v-autocomplete>
            </v-col>
            <v-col class="12" md="12">
              <v-autocomplete
                v-model="filter.partner"
                :items="users"
                item-text="name"
                item-value="id"
                outlined
                label="Parceiro teste"
                dense
                small-chips
                hide-details
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row class="d-flex flex-row justify-end align-center mt-5 px-3">
            <v-btn
              text
              class="mx-2"
              @click="clean()"
            >Limpar</v-btn>
            <v-btn
              color="primary"
              @click="$emit('apply', filter)"
            >Pesquisar</v-btn>
          </v-row>
        </v-card>
      </v-container>
    </v-card>
  </v-menu>
</template>

<script>
import { GET_USERS_BY_TYPE_QUERY } from '../graphql/Query.gql'
import { mapGetters } from 'vuex'
export default {
  name: 'TestFilter',
  data: () => ({
    filter: {
      areas: undefined,
      category: undefined,
      partner: undefined,
      positions: undefined
    },
    users: []
  }),
  apollo: {
    users: {
      query: GET_USERS_BY_TYPE_QUERY,
      variables() {
        return { type: "partner" }
      }
    }
  },
  computed: {
    ...mapGetters({
      getTrainingAreas: 'library/trainingAreas',
      getPositions: 'library/positions'
    }),
    categories () {
      return [
        { text: 'Compreensão Verbal', key: 'verbalUnderstanding' },
        { text: 'Habilidades', key: 'skills' },
        { text: 'Jogos', key: 'games' },
        { text: 'Julgamento Situacional', key: 'situationalJudgment' },
        { text: 'Pensamento Abstracto', key: 'abstractThinking' },
        { text: 'Personalidade', key: 'personality' },
        { text: 'Raciocínio Lógico', key: 'logicalReasoning' },
        { text: 'Simulação', key: 'simulation' },
      ]
    },
  },
  methods: {
    clean () {
      this.filter = {
        areas: undefined,
        category: undefined,
        positions: undefined
      }
      this.$emit('clean')
    }
  }
}
</script>